import ApiService from '@shared/services/api.service';

const endPoint = '/custom_element';

const CustomElementService = {
  getList() {
    return ApiService.get(endPoint);
  },

  createCustomElement(element_name, description, xpath){
    return ApiService.post(endPoint, {"element_name": element_name, "description": description, "xpath": xpath});
  },

  delete(elementId){
    return ApiService.delete(`${endPoint}/${elementId}`);
    // return ApiService.delete(`${endPoint}/5`);
  }
};
export default CustomElementService;
